import { Progress } from "../ui/Progress";

type BoundedProgressProps = {
  current: number;
  progress: number;
  max: number;
  variant: "white" | "black";
};

export const BoundedProgress = ({
  current,
  progress,
  max,
  variant,
}: BoundedProgressProps) => {
  return (
    <div
      className={`flex w-full justify-center items-center gap-4 shrink-0 font-minion px-[14px] ${
        variant === "white" ? "text-white" : "text-black"
      }`}
    >
      {current}
      <Progress
        value={progress}
        className="w-full"
        variant={variant}
      />
      {max}
    </div>
  );
};
